import React from "react";
import contextProvider from "app/contextProvider";
import _ReactOBaseComponent from "app/_L0_components/_ReactOBaseComponent";
import Section from "app/_L1_components/Layout/Section";
import Panel from "app/_L1_components/Layout/Panel";
import ReactOForm from "app/_L1_components/Elements/ReactOForm";
import ReactOFormInput from "app/_L1_components/Elements/ReactOFormInput";
import fontContent from "fontContent";

const text = fontContent.text;

class FontDemo extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {};
    super(props, initState);
  }

  onComponentDidMount() {
    this.selectedContent = fontContent[this.props.match.params.fontid];
    document.title = this.selectedContent.title;
    this._notes_editing_form.init();
  }

  onRender() {
    return (
      <Section
        designType="narrow"
        className="mt-3"
        // className="border-bottom border-2 border-gray300"
        // style={}
      >
        <h4>{this.selectedContent ? this.selectedContent.title : "-"}</h4>
        <div>
          <ReactOForm
            // unsavedWarning
            onControllerReady={(form_controller) => {
              this._notes_editing_form = form_controller;
            }}
            onFormDataChange={(form_data) => {
              this.setState({ textWrite: form_data.text });
            }}
          >
            <ReactOFormInput
              inputClassName="my-4 input-base_style"
              type="textarea"
              data_key="text"
              placeholder={text}
              // autofocus={data && (data._pre_ts || data.id) ? true : false}
              size="md"
              default=""
            />
          </ReactOForm>
        </div>
        <Panel
          bgColor="#fff"
          className={
            this.selectedContent
              ? this.selectedContent.background
                ? this.selectedContent.background + " mt-2"
                : "mt-2"
              : ""
          }
          rounded
          style={
            this.selectedContent
              ? this.selectedContent.panelStyle
                ? this.selectedContent.panelStyle
                : null
              : null
          }
          // header={fontContent[this.props.match.params.fontid].title}
        >
          {this.selectedContent ? (
            this.selectedContent.pre ? (
              <this.selectedContent.pre.tag
                className={
                  this.selectedContent.pre.class ? this.selectedContent.pre.class : null
                }
              >
                <this.selectedContent.tag
                  className={
                    this.selectedContent.class ? this.selectedContent.class : null
                  }
                  style={this.selectedContent.style ? this.selectedContent.style : null}
                >
                  {this.state.textWrite ? this.state.textWrite : text}
                </this.selectedContent.tag>
              </this.selectedContent.pre.tag>
            ) : (
              <this.selectedContent.tag
                className={this.selectedContent.class ? this.selectedContent.class : null}
                style={this.selectedContent.style ? this.selectedContent.style : null}
              >
                {this.state.textWrite ? this.state.textWrite : text}
              </this.selectedContent.tag>
            )
          ) : null}
        </Panel>
      </Section>
    );
  }
}

export default contextProvider(FontDemo, {
  define: null,
});
